export default "__VITE_ASSET__DARP4zpA__"